export const countriesDataModel = {
  state: () => ({
    /** для вывода уведомления пользователя из другой страны start */
    countryIpId: 643,
    countryIpName: 'Россия',
    showModal: false,
    /** end */

    /** список со странами, переключение между доменами start */
    currencyDto: [],
    isGuest: false,
    listCurrency: [],
    listCountriesDomain: [],
    protocolHttps: '',
    loading: false
    /** end */
  }),
  namespaced: true,
}